<template>
  <article class="slider-logo__container">
    <transition-group tag="div" class="slider-logo" name="slider-logo">
      <img v-for="logo in activeLogos" :key="logo.key" :src="logo.src" :class="['slider-logo__item', logo.modifier]" />
    </transition-group>
  </article>
</template>

<script>
export default {
  name: 'HomeLogos',
  data() {
    return {
      logos: [
        { src: '/images/logo.png', key: 'a' },
        { src: '/images/logo-medium.svg', key: 'b' },
        { src: '/images/logo.png', key: 'c' },
        { src: '/images/logo-medium.svg', key: 'd' },
        { src: '/images/logo.png', key: 'e' },
        { src: '/images/logo-medium.svg', key: 'f' },
        { src: '/images/logo.png', key: 'g' },
        { src: '/images/logo-medium.svg', key: 'h' },
        { src: '/images/logo.png', key: 'i' },
        { src: '/images/logo-medium.svg', key: 'j' }
      ],
      activeLogos: [],
      standbyLogos: [],
      interval: null
    }
  },
  computed: {
    sliderSize() {
      if (this.$device.desktop) return 7
      if (this.$device.laptop) return 6
      if (this.$device.tabletH) return 5
      if (this.$device.tablet) return 4
      return 3
    }
  },
  watch: {
    sliderSize: {
      immediate: true,
      handler() {
        this.clearSlider()
        this.setupSlides()
        this.startSlider()
      }
    }
  },
  beforeDestroy() {
    this.clearSlider()
  },
  methods: {
    setupSlides() {
      const logos = this.logos.length <= this.sliderSize ? [...this.logos, ...this.logos] : this.logos
      this.activeLogos = logos.slice(0, this.sliderSize)
      this.standbyLogos = logos.slice(this.sliderSize)
    },
    startSlider() {
      this.interval = setInterval(this.shiftLogos, 3000)
    },
    clearSlider() {
      if (!this.interval) return
      clearInterval(this.interval)
      this.interval = null
    },
    shiftLogos() {
      this.standbyLogos.push(this.activeLogos.shift())
      this.activeLogos.push(this.standbyLogos.shift())
    }
  }
}
</script>
